var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaperBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.903,
    height: 39.737,
    viewBox: "0 0 29.903 39.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 29.903,
    height: 39.737,
    transform: "translate(0 0)",
    fill: "#cea95a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3031",
    "data-name": "Groupe 3031",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3030",
    "data-name": "Groupe 3030",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36701",
    "data-name": "Trac\\xE9 36701",
    d: "M14.951,0a5.119,5.119,0,0,0-4.943,3.814H1.924A1.926,1.926,0,0,0,0,5.737V37.813a1.926,1.926,0,0,0,1.924,1.924H27.979A1.926,1.926,0,0,0,29.9,37.813V5.737a1.926,1.926,0,0,0-1.924-1.924H19.894A5.119,5.119,0,0,0,14.951,0m0,1.8A3.315,3.315,0,0,1,18.263,5.11V7.4a.9.9,0,0,0,.9.9,2.574,2.574,0,0,1,2.408,1.671H8.333A2.574,2.574,0,0,1,10.741,8.3a.9.9,0,0,0,.9-.9V5.11A3.315,3.315,0,0,1,14.951,1.8m0,1.918A1.393,1.393,0,1,0,16.345,5.11a1.395,1.395,0,0,0-1.393-1.393m0,.989a.4.4,0,1,1-.4.4.405.405,0,0,1,.4-.4M1.924,5.611H9.842V6.59A4.349,4.349,0,0,0,8.3,7.241H4.052a.9.9,0,0,0-.9.9V35.685a.9.9,0,0,0,.9.9h21.8a.9.9,0,0,0,.9-.9V8.14a.9.9,0,0,0-.9-.9H21.6a4.341,4.341,0,0,0-1.537-.651V5.611h7.918a.126.126,0,0,1,.126.126V37.813a.126.126,0,0,1-.126.126H1.924a.126.126,0,0,1-.126-.126V5.737a.126.126,0,0,1,.126-.126M4.952,9.039H6.773a4.342,4.342,0,0,0-.4,1.826.9.9,0,0,0,.9.9H22.631a.9.9,0,0,0,.9-.9,4.336,4.336,0,0,0-.4-1.826h1.822V34.785h-20V9.039",
    transform: "translate(0 0)",
    fill: "#cea95a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperBoard);
export default __webpack_public_path__ + "static/media/iconPaperBoard.92dc939efc9225acc47728e10ebb5dda.svg";
export { ForwardRef as ReactComponent };